// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_id-0";
export var actionModalContentContainer = "_id-1";
export var createTagButton = "_id-2";
export var footerContainer = "_id-7";
export var fullWidthDivider = "_id-3";
export var hasCreateTagButton = "_id-4";
export var noCreateTagButton = "_id-5";
export var tagsContainer = "_id-6";
export var tagsModalContentContainer = "_id-8";